import React from 'react';
import type { MusicEventProps } from '../../../types';
import { EventDetailsMainInner } from '../EventDetails';
import './MusicEventsInfo.scss';

type MusicEventsInfoProps = Pick<MusicEventProps, 'presenter'>;

export const MusicEventsInfo = ({ presenter }: MusicEventsInfoProps) => {
    if (!presenter) {
        return null;
    }

    return (
        <EventDetailsMainInner>
            <ul className="music-event-info">
                <li>{presenter}</li>
            </ul>
        </EventDetailsMainInner>
    );
};
